import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import UserUtils from "services/user/utils";

import useGaTracker from "services/hooks/useGaTracker";
import usePageTitleUpdater from "services/hooks/usePageTitleUpdater";
import { HeaderTabsProvider } from "services/common/HeaderTabsProvider";

import MobileAppAlert from "components/MobileAppAlert";

const styles = {
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
  },
};

function AppRouting({ user, routes }) {
  useGaTracker();
  usePageTitleUpdater();

  return (
    <div style={styles.container}>
      <MobileAppAlert />
      <Switch>
        {routes.map(
          ({ enabled, render: Render, props: routeProps }) =>
            enabled && (
              <Render
                key={`${routeProps.path}${routeProps.exact ? "-exact" : ""}`}
                {...routeProps}
              />
            )
        )}

        <Route path="*">
          <Redirect to={UserUtils.getDefaultRoute(user)} />
        </Route>
      </Switch>
    </div>
  );
}

function Router({ user, routerHistory, routes }) {
  return (
    <ConnectedRouter history={routerHistory}>
      <HeaderTabsProvider>
        <AppRouting routes={routes} user={user} />
      </HeaderTabsProvider>
    </ConnectedRouter>
  );
}

Router.propTypes = {
  routerHistory: PropTypes.objectOf(PropTypes.any).isRequired,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      render: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
        PropTypes.elementType,
        PropTypes.element,
      ]),
      props: PropTypes.shape({
        exact: PropTypes.bool,
        path: PropTypes.string,
        component: PropTypes.oneOfType([
          PropTypes.object,
          PropTypes.func,
          PropTypes.elementType,
          PropTypes.element,
        ]),
      }),
    })
  ),
};

const mapStateToProps = (state) => ({
  user: state.User,
});

export default connect(mapStateToProps)(Router);
